import { motion } from 'framer-motion'

export default function GraffitiLogo({ className = 'h-12 w-12', animated = true }) {
  const logoContent = (
    <img 
      src="/graffiti-logo.png" 
      alt="Graffiti™" 
      className={`${className} object-contain`}
    />
  )

  if (animated) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="inline-flex"
      >
        {logoContent}
      </motion.div>
    )
  }

  return <div className="inline-flex">{logoContent}</div>
}

// Simplified inline version for smaller uses
export function GraffitiLogoSimple({ className = 'h-8 w-8' }) {
  return (
    <img 
      src="/graffiti-logo.png" 
      alt="Graffiti™" 
      className={`${className} object-contain`}
    />
  )
}